import { Input } from "antd";
import { debounce } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import { getFieldErrors, getFieldStatus } from '../../library/helpers/forms';

const InputWrapper = ({ name, defaultValue = null, label = null, delay = false, onChange, errors = {}, textarea = false, required = false, ...otherProps }) => {
    const changeHandler = delay ? debounce(onChange, 500) : onChange
    const InputComponent = textarea ? Input.TextArea : Input

    return (
        <FieldWrapper name={name} label={label} errors={errors} required={required}>
            <InputComponent name={name ?? undefined} defaultValue={defaultValue} onChange={onChange ? changeHandler : undefined} {...otherProps} required={required} status={getFieldStatus(name, errors)} key={defaultValue} />
        </FieldWrapper>
    )
}

InputWrapper.propTypes = {
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    delay: PropTypes.bool,
    onChange: PropTypes.func,
    errors: PropTypes.object,
    textarea: PropTypes.bool,
    required: PropTypes.bool
}

const FieldWrapper = ({ name, label = null, errors = null, required = false, children }) => {
    return (
        <div className="form-field">
            {!!label && (
                <label className={required ? 'form-label-required' : undefined}>
                    {label}
                    {required && <span className="form-label-required__asterisk" aria-hidden="true">*</span>}
                </label>
            )}
            {children}
            {!!errors && getFieldErrors(name, errors)}
        </div>
    )
}

FieldWrapper.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    errors: PropTypes.object,
    required: PropTypes.bool,
    children: PropTypes.node.isRequired
}

const GeneralFieldWrapper = ({ label = null, children }) => {
    return (
        <div className="form-field">
            {!!label && <label>{label}</label>}
            {children}
        </div>
    )
}

GeneralFieldWrapper.propTypes = {
    label: PropTypes.string,
    children: PropTypes.node.isRequired
}

export { FieldWrapper, GeneralFieldWrapper, InputWrapper };
